import React from "react";
import TestsID from "../../../utils/TestsID";
import KC_Span from "../../../designsystem/KC_Span/KC_Span";
import KC_Colors from "../../../designsystem/KC_Colors";

interface KCErrorMessageI {
  id?: string;
  children: any;
}

const KCErrorMessage = ({ children, id }: KCErrorMessageI) => (
  <KC_Span
    text={children}
    id={`${TestsID.KC_INPUT_ERROR}-${id}`}
    color={KC_Colors.Error}
  />
);

export default KCErrorMessage;
